import * as React from 'react';
import { Box } from '@mui/material';

export const ActionSpacer: React.FC = () => {
  return <Box aria-hidden sx={{ height: '50px', width: '100%' }} />;
};

